import { AppBar, Typography } from '@mui/material';
import BaseModal from '../../../admin/modals/base-modal';

type PropTypes = {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
};

const InsuranceUsageInfoModal = ({ isOpen, setIsOpen }: PropTypes) => (
  <BaseModal
    isOpen={isOpen}
    cancelButtonText=""
    handleCancel={() => setIsOpen(false)}
  >
    <AppBar sx={{ p: 2 }}>
      <Typography variant="h6">Do I have to use insurance?</Typography>
    </AppBar>
    <Typography sx={{ mb: 4, mt: 6 }}>
      Right now, we can only see patients whose insurance we accept. We’re
      always working to expand the number of insurers and plans we take.
    </Typography>
    <Typography>
      If you’d prefer a self-pay option, we recommend using Zocdoc or Psychology
      Today to find a clinician in your area.
    </Typography>
  </BaseModal>
);

export default InsuranceUsageInfoModal;
